export default {
  Search : function(query, self, onsuccess, onfailed) {
    return {
        data : {     
          AuthorizationToken : self.props.UserReducer.token,
          Path  : self.props.urlKey,
          Extra : self.props.extra,
          Query : query
        },
        self : self,
        onsuccess : onsuccess,
        onfailed : onfailed,
    }
  },
}


// WEBPACK FOOTER //
// ./src/App/component/helper/request.props.js